export const GET_NOTIFICATION_RECORDS = `
  query ($page: ID!, $q: String, $status: String, $notificationType: String, $notificationCategory: String) {
    notifierRecords(page: $page, q: $q, status: $status, notificationType: $notificationType, notificationCategory: $notificationCategory) {
      count
      errors{
        description
      }
      results{
        id
        notificationType
        notificationCategory
        status
        message
        recipient
        reference
        createdAt
        updatedAt
        customer {
          id
          petraId
        }
        company {
          id
          petraId
        }
        trustee {
          id
          company {
            id
            petraId
          }
        }
      }
    }
  }
`;

export const CHECK_EMAIL_DELIVERY_STATUS = `
  mutation CheckEmailDeliveryStatus($id: ID!) {
    checkEmailDeliveryStatus(id: $id) {
      notifierRecord {
        id
        status
        rejectReason
        updatedAt
      }
      errors {
        description
        property
      }
    }
  }
`;

export const GET_NOTIFICATION_RECORD = `
  query GetNotificationRecord($id:ID!) {
    notifierRecord(id: $id ){
        id
        notificationType
        status
        message
        details
        recipient
        reference
        rejectReason
        attachments
        customer {
          id
          petraId
        }
        company {
          id
          petraId
        }
        trustee {
          id
          company {
            id
            petraId
          }
        }
        createdAt
        updatedAt
    }
  }
`;
